module.exports = __webpack_public_path__ + "img/qr-code.6498152f.png";